import React from 'react';
import { Typography } from '@material-ui/core';
import { StyledBox } from '../textWithClicks/TextWithClicks.styled';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded';

const CustomLabel = ({
    fSize,
    color,
    opacity,
    cursor,
    label,
    onLabelClick,
    fWeight,
    wSpace,
    styles,
    minWidth,
    fontFamily,
    marginLeft,
    marginRight,
    marginBottom,
    textAlign,
    width,
    mdPaddingRight,
    ldPaddingRight,
    marginRightQty,
    wordBreak,
    spanIcon,
    itemDescription,
    paddingLeft,

    ...rest
}) => {
    return (
        <StyledBox
            component={Typography}
            fontSize={fSize}
            color={color}
            itemDescription={itemDescription}
            marginRight={marginRightQty}
            fontWeight={fWeight}
            {...rest}
            style={{
                cursor: cursor,
                opacity: opacity,
                whiteSpace:  wSpace,
                // whiteSpace: itemDescription ? 'nowrap' : wSpace,
                // overflow: itemDescription && 'hidden',
                // textOverflow: itemDescription && 'ellipsis',
                fontFamily: fontFamily ? fontFamily : 'AvenirNextWorld Demi',
                marginLeft: marginLeft,
                marginRight: marginRight,
                marginBottom: marginBottom,
                width: width,
                wordBreak: wordBreak,
                textDecoration: 'none',
                WebkitTextDecoration: 'none',
                WebkitAppearance: 'none',
                // marginTop: itemDescription && '32px',
                //  marginLeft:label==='+Lot/Serial#'&&'670px',
                ...styles,
            }}
            onClick={onLabelClick}
            minWidth={minWidth}
            textAlign={textAlign}
            mdPaddingRight={mdPaddingRight}
            ldPaddingRight={ldPaddingRight}
            id={rest.id || `custom-label-${label?.toString().replace(/\s+/g, '-').toLowerCase()}`}
        >
            {spanIcon && (
                <ErrorOutlineRounded
                    style={{
                        width: '26px',
                        height: '26px',
                        color: color,
                        alignSelf: 'baseline',
                        paddingBottom: '4px',
                        paddingRight: '5px',
                    }}
                />
            )}
            {label}
        </StyledBox>
    );
};

export default CustomLabel;
